module.exports = __webpack_public_path__ + "img/excel.1f89eb26.svg";